module.exports = __webpack_public_path__ + "static/media/Flame.b4628105.png";